// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.click-to-call-warning-content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.click-to-call-warning-content-wrapper .click-to-call-warning-content {
  padding: 24px;
}
.click-to-call-warning-content-wrapper .click-to-call-warning-content .click-to-call-warning-icon {
  display: flex;
  width: 48px;
  height: 48px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border-radius: var(--full, 9999px);
  background: var(--colors-background-bg-warning-secondary, #FEF0C7);
  margin-bottom: 16px;
}
.click-to-call-warning-content-wrapper .click-to-call-warning-content .click-to-call-warning-icon svg path {
  stroke: #DC6803;
}
.click-to-call-warning-content-wrapper .click-to-call-warning-content h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: var(--font-size-text-md, 16px);
  font-weight: var(--font-weight-normal-Semibold, 600);
  line-height: var(--font-line-height-text-md, 24px);
  margin-bottom: 4px;
}
.click-to-call-warning-content-wrapper .click-to-call-warning-content p {
  color: var(--sdk-gloabl-text-color);
  opacity: 0.5;
  font-size: var(--font-size-text-sm, 14px);
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: var(--font-line-height-text-sm, 20px);
}
.click-to-call-warning-content-wrapper .click-to-call-warning-actions-wrapper {
  display: flex;
  padding: var(--md, 12px) var(--default, 24px);
  flex-direction: column;
  align-items: flex-end;
  gap: var(--Gutter-CTA, 8px);
  align-self: stretch;
}`, "",{"version":3,"sources":["webpack://./src/plugins/agentDesktop/clickToCallSlider.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAAJ;AACI;EACI,aAAA;AACR;AAAQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kEAAA;EACA,mBAAA;AAEZ;AAAgB;EACI,eAAA;AAEpB;AAEQ;EACI,mCAAA;EACA,yCAAA;EACA,oDAAA;EACA,kDAAA;EACA,kBAAA;AAAZ;AAEQ;EACI,mCAAA;EACA,YAAA;EACA,yCAAA;EACA,mDAAA;EACA,kDAAA;AAAZ;AAGI;EACI,aAAA;EACA,6CAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;AADR","sourcesContent":["\n.click-to-call-warning-content-wrapper{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    .click-to-call-warning-content{\n        padding: 24px;\n        .click-to-call-warning-icon{\n            display: flex;\n            width: 48px;\n            height: 48px;\n            padding: 12px;\n            justify-content: center;\n            align-items: center;\n            border-radius: var(--full, 9999px);\n            background: var(--colors-background-bg-warning-secondary, #FEF0C7);\n            margin-bottom: 16px;\n            svg{\n                path{\n                    stroke: #DC6803;\n                }\n            }\n        }\n        h1{\n            color: var(--sdk-gloabl-text-color);\n            font-size: var(--font-size-text-md, 16px);\n            font-weight: var(--font-weight-normal-Semibold, 600);\n            line-height: var(--font-line-height-text-md, 24px);\n            margin-bottom: 4px;\n        }\n        p{\n            color: var(--sdk-gloabl-text-color);\n            opacity: 0.5;\n            font-size: var(--font-size-text-sm, 14px);\n            font-weight: var(--font-weight-normal-Regular, 400);\n            line-height: var(--font-line-height-text-sm, 20px);\n        }\n    }\n    .click-to-call-warning-actions-wrapper{\n        display: flex;\n        padding: var(--md, 12px) var(--default, 24px);\n        flex-direction: column;\n        align-items: flex-end;\n        gap: var(--Gutter-CTA, 8px);\n        align-self: stretch;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
